var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DialogLogin',{attrs:{"visible":_vm.dialogLoginVisible}}),_c('DialogRegister',{attrs:{"visible":_vm.dialogRegisterVisible}}),_c('DialogImage',{attrs:{"visible":_vm.dialogImageVisible,"detail":_vm.dialogImageDetail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }